<template>
  <div class="dashboard-container">
    <div class="dashboard-depart" style="background:#f8f8f8;" v-for='dashboard in dashboard' :key='dashboard.name'>
      <h4 style="padding:10px 0px 0px 10px;margin-bottom:0px;color:#3a4a64;">{{dashboard.name}}</h4>
      <div class="hello" >
        <div  style='background:#fff;height:380px;margin:10px 0px 10px 1%;display:inline-block;text-align: center;float:left;width:43.5%;'>
          <div>
            <h4 style="margin-left:20px;color:#3a4a64;text-align: left;">待办事项</h4>
          </div>
          <div style="width:33%;height:150px;display:inline-block;text-align:center;margin-top:40px;" v-for='toDoList in dashboard.toDoList' :key='toDoList.id'>
              <span style="color:#3a4a64;">{{toDoList.todoCount}}</span>
              <Chart :id="dashboard.departmentId+'_'+toDoList.type" :type='true' :option="toDoList" :width='piewidth' :height='pieheight' ></Chart>
              <span style="color:#3a4a64;">{{toDoList.typeName}}</span>
          </div>
        </div>
        <div  style='background:#fff;height:380px;margin:10px 1% 10px 1%;display:inline-block;float:right;width:53.5%;'>
          <div>
            <h4 style="margin-left:20px;color:#3a4a64;">近七天工作量</h4>
          </div>
          <div style="width:100%;height:150px;display:inline-block;" >
              <Chart :id="id+'_'+dashboard.departmentId" :type='false' :option="dashboard" :width='barwidth' :height='barheight' ></Chart>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="dashboard-text">name:{{name}}</div>
    <div class="dashboard-text">roles:{{currentUserRoleDepart.roleName}}</div> -->
      <el-dialog title="重置密码" :visible.sync="pwdVisible" width="500px"  custom-class='revisitDialog' ref="dialog">
          <el-form size='mini' :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
            <!-- <el-form-item label="原密码" prop="oldPwd">
              <el-input type="password" v-model="ruleForm2.oldPwd" auto-complete="off"></el-input>
            </el-form-item> -->
            <el-form-item label="新密码" prop="newPwd">
              <el-input type="password" v-model="ruleForm2.newPwd" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
              <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
            </el-form-item>
            <!-- <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm2')">保存</el-button>
            </el-form-item> -->
          </el-form>
        <div style="font-size:10px;color:#F56C6Cl;margin-top:40px">*由于您的密码强度太低，需强制重置密码</div>
        <div style="font-size:10px;color:#F56C6C">新密码需由包含大写字母、小写字母、数字且9位及以上</div>
        <template #footer>
          <span class="dialog-footer" style="margin-right:20px">
            <el-button size="small" @click="pwdVisible=false" >
              下次再说
            </el-button>
          </span>
          <span class="dialog-footer">
            <el-button type="primary" size="small" @click="submitForm('ruleForm2')">
              确定
            </el-button>
          </span>
        </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Chart from '../Common/eCharts'
export default {
  name: 'Dashboard',
  components: {
    Chart
  },
  computed: {
    ...mapGetters([
      'name',
      'roles',
      'currentUserRoleDepart',
      'dashboard'
    ])
  },
  data() {
    var validatePass = (rule, value, callback) => {
      let regx = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{9,}$/
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if(!regx.test(value)){
        callback(new Error('需由包含大写字母、小写字母、数字且9位及以上组成'))
      } else {
        if (this.ruleForm2.checkPass !== '') {
          this.$refs.ruleForm2.validateField('checkPass')
        }
        if (value.length < 8) {
          callback(new Error('密码不能小于8位'))
        } else {
          callback()
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm2.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        if (value.length < 6) {
          callback(new Error('密码不能小于6位'))
        } else {
          callback()
        }
        callback()
      }
    }
    return {
      id: 'bar',
      piewidth: '100%',
      pieheight: '150px',
      barwidth: '100%',
      barheight: '300px',
      pwdVisible:false,
      rules2: {
        newPwd: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      ruleForm2: {
        // oldPwd: '',
        checkPass: '',
        newPwd: ''
      },
    }
  },

  beforeMount() {
  },
  mounted() {
    this.init()
  },
  created() {
    let regx = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{9,}$/
    let pwd = JSON.parse(sessionStorage.getItem('pwd')).Password
    if (!regx.test(pwd)) {
      this.pwdVisible = true
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.Loading = true
          this.$store
            .dispatch('ChangeUserPwd', { newPwd: this.ruleForm2.newPwd, oldPwd: this.ruleForm2.oldPwd })
            .then(() => {
              this.Loading = false
              this.$store.dispatch('LogOut').then(() => {
                // 清除自动登录信息
                var loginAutoFromLocalStorage = localStorage.getItem('loginAuto')
                if (loginAutoFromLocalStorage) {
                  localStorage.removeItem('loginAuto')
                  localStorage.removeItem('userinfo')
                }
                location.reload()
              }).catch(() => {
                location.reload()
              })
            })
            .catch(() => {
              this.Loading = false
            })
        } else {
          return false
        }
      })
    },
    init() {
      this.$store.dispatch('GetDashboard').then(() => { //
        for (var i = 0; i < this.dashboard.length; i++) {
          for (var j = 0; j < this.dashboard[i].toDoList.length; j++) {
            // var undoName = '' doName = ''
            // if (this.dashboard[i].toDoList[j].type === 1) {
            //   undoName = '剩余检查'
            //   doName = '已检查'
            // }

            // this.pieOption.series[0].name = '检查'
            // this.pieOption.series[0].data = arr
          }
        }
      }).catch(() => {
        this.$message({ message: '获取检查部位失败，请重新获取', type: 'warning' })
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard {
  &-container {
    margin: 20px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.charts-list{

}
.dashboard-container,{
  height: calc(100vh - 120px);

}
.dashboard-depart{
  height: 435px;
  background: #f8f8f8;
}
</style>
